import React from "react";
import "./BrandSection.css";

const blogo1 = "/logo_.png";

export const logoData = [
  {
    name: "logo 1",
    img: blogo1,
  },
  {
    name: "logo 2",
    img: blogo1,
  },
  {
    name: "logo 3",
    img: blogo1,
  },
  {
    name: "logo 4",
    img: blogo1,
  },
  {
    name: "logo 5",
    img: blogo1,
  },
  {
    name: "logo 6",
    img: blogo1,
  },
  {
    name: "logo 7",
    img: blogo1,
  },
  {
    name: "logo 8",
    img: blogo1,
  },
  {
    name: "logo 9",
    img: blogo1,
  },
  {
    name: "logo 10",
    img: blogo1,
  },
];

const BrandSection = (props) => {
  const { images } = props;
  const logoImages = Array.isArray(images) ? images : logoData;
  const animatedLogos = [...logoImages, ...logoImages];

  return (
    <>
      <section className="brand-section">
        <div className="container">
          <div className="brand-row-wrapper" data-aos="fade-up">
            <div className="brand-marquee">
              {animatedLogos.map((d, index) => (
                <a className="inner_img" href="#" key={`${d.name}-${index}`}>
                  <img src={d.img} alt={d.name}></img>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BrandSection;
